/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jobticketdatenweitergabe2Inputs */



/**

* @param {_Field_Jobticketdatenweitergabe2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jobticketdatenweitergabe2 = /** @type {((inputs?: _Field_Jobticketdatenweitergabe2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jobticketdatenweitergabe2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jobticket Datenweitergabe")
});
export { _field_jobticketdatenweitergabe2 as "_field_jobTicketDatenweitergabe" }